/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
var __webpack_exports__ = {};
// extracted by mini-css-extract-plugin
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({"c-page__content":"c-page__content","is-reduced-margin":"is-reduced-margin","o-accordions":"o-accordions","c-page-template--page-faq":"c-page-template--page-faq","c-page__container":"c-page__container"});
/******/ })()
;